import React, { useMemo } from 'react';
import isNumber from 'lodash/isNumber';
import { judgeResponsiveSize } from '@/utils/responsive';
/**
 * @category 组件
 * @description 栅格布局
 */
const CnGridLayout = (props) => {
    const { grids, gutter, responsive, children, ...rest } = props;
    const calculatedGutter = useMemo(() => {
        let rowGutter = 8;
        let colGutter = 12;
        if (Array.isArray(gutter) && gutter.length > 0) {
            if (gutter.length === 1) {
                rowGutter = gutter[0];
                colGutter = gutter[0];
            }
            else {
                rowGutter = gutter[0];
                colGutter = gutter[1];
            }
        }
        return { rowGutter, colGutter };
    }, [gutter]);
    const calculatedColumns = useMemo(() => {
        let columns = 4;
        if (responsive) {
            if (grids && grids instanceof Object) {
                const gridsObj = Object(grids);
                const responsiveSize = judgeResponsiveSize();
                if (gridsObj[responsiveSize]) {
                    columns = gridsObj[responsiveSize];
                }
            }
        }
        else if (isNumber(grids)) {
            columns = grids;
        }
        return columns;
    }, [responsive, grids]);
    const styleStyledGridLayout = {
        width: '100%',
        display: 'grid',
        gridRowGap: `${calculatedGutter.rowGutter}px`,
        gridColumnGap: `${calculatedGutter.colGutter}px`,
        gridTemplateColumns: `repeat(${calculatedColumns}, minmax(0, 1fr))`,
    };
    return (React.createElement("div", { style: styleStyledGridLayout, ...rest }, children));
};
/**
 * @category 组件
 * @description 栅格布局子组件，上层组件为 CnGridLayout
 */
const CnGridItem = (props) => {
    const { colSpan, children, style, ...rest } = props;
    const calculatedColSpan = useMemo(() => {
        let spans = 1;
        if (colSpan instanceof Object) {
            const spanObj = Object(colSpan);
            const responsiveSize = judgeResponsiveSize();
            if (spanObj[responsiveSize]) {
                spans = spanObj[responsiveSize];
            }
        }
        else {
            spans = Number(colSpan || 1);
        }
        return spans;
    }, [colSpan]);
    const styledGridLayoutItem = {
        gridColumnEnd: `span ${calculatedColSpan}`,
        gridRowEnd: `span ${rest.rowSpan}`,
        ...style,
    };
    return (React.createElement("div", { ...rest, style: styledGridLayoutItem }, children));
};
const styledGridLayoutItemDemo = {
    display: 'flex',
    background: '#c0ccdd',
    color: 'white',
    justifyContent: 'center',
};
const CnGridItemDemo = (props) => {
    return React.createElement("span", { style: styledGridLayoutItemDemo }, props.children);
};
const CnGrid = {
    CnRow: CnGridLayout,
    CnCol: CnGridItem,
};
export * from './types';
export { CnGrid, CnGridLayout, CnGridItem, CnGridItemDemo };
